<template>
  <div class="body-container border-container">
    <div class="progress-container select-scroll">
      <div class="progress-box">
        <div class="">
          <div class="text-center pb-20 overall-progress-info">
            <span class="font-weight-bold" v-translate:dashboard_over_progress="lang">Overall Progress</span>
            <div class="dashboard-info tooltip mr-15">
              <a class="d-inline-block" @mouseover="oncallInformation('Overall'), (upHere = true)" @mouseleave="upHere = false">
                <img class="ml-5" src="static/img/participant-portal/info_button.svg" alt="info_button" />
              </a>
              <div v-if="information" v-show="upHere">
                <span class="tooltiptext  progress-tooltip" v-if="information.type == 'Overall'" v-html="information.message"></span>
              </div>
            </div>
          </div>
          <div class="col pl-5 pr-5">
            <div class="progress">
              <div class="progress-bar" role="progressbar" :style="{ width: progressBarPercentage + '%', backgroundColor: globalElement ? globalElement.primaryColor : 'var(--primary)' }" :aria-valuenow="progressBarPercentage" aria-valuemin="0" aria-valuemax="100">
                <span>{{ progressBarPercentage }}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center pt-10">
          <div class="progress-status status-completed text-center">
            <p class="title black mb-0" v-translate:dashboard_completed_title="lang">Completed</p>
            <p class="content mb-0 primary-text fs-14">
              <span class="text1">{{ completed.day }}</span> <span class="text3" v-translate:pnl_day="lang">d</span>
            </p>
          </div>
          <div class="progress-status status-remaining text-center">
            <p class="title black mb-0" v-translate:dashboard_remaining_title="lang">Remaining</p>
            <p class="content mb-0 primary-text fs-14">
              <span class="text1">{{ remaining.month }}</span
              ><span class="text3" v-translate:pnl_month="lang">m</span> &nbsp; <span class="text1">{{ remaining.day }}</span> <span class="text3" v-translate:pnl_day="lang">d</span>
            </p>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column pt-36 pb-tablet">
        <div class="">
          <div class="activity-section">
            <div class="card">
              <div class="card-body">
                <div class="card-title">
                  <span v-translate:dashboard_todays_activities="lang">Today’s Activities</span>
                  <div class="dashboard-info tooltip mr-15">
                    <a class="d-inline-block" @mouseover="oncallInformation('today'), (upHere = true)" @mouseleave="upHere = false">
                      <img class="ml-5" src="static/img/participant-portal/info_button.svg" alt="info_button" />
                    </a>
                    <div v-if="information" v-show="upHere">
                      <span class="tooltiptext activity-tooltip" v-if="information.type == 'today'" v-html="information.message"></span>
                    </div>
                  </div>
                </div>
                <div v-if="checkForStudyStart != null" class="text-center pt-17">
                  <h3 style="padding-top: 127px;">{{ checkForStudyStart }}</h3>
                </div>
                <div v-else-if="statusActivity != null" class="text-center pt-17">
                  <h3 style="padding-top: 127px;">{{ statusActivity }}</h3>
                </div>
                <div v-else>
                  <doughnut v-if="data && contentLoaded" :height="450" :activity="activities.length" :data="data" :options="options"></doughnut>
                </div>
              </div>
            </div>
            <div class="text-center pt-17 pb-17" v-if="checkForStudyStart == null">
              <button class="btn text-white primary-bg" @click="activityPage('activity')" :disabled="countRemaining.status" v-if="countRemaining.message">{{ countRemaining.message }}</button>
            </div>
          </div>
        </div>
        <div class="pt-36" v-if="milestones.length > 0">
          <div class="activity-section">
            <div class="card">
              <div class="card-body">
                <div class="card-title">
                  <span v-translate:dashboard_milestones="lang">Milestones</span>
                  <div class="dashboard-info tooltip mr-15">
                    <a class="d-inline-block" @mouseover="oncallInformation('Milestone'), (upHere = true)" @mouseleave="upHere = false">
                      <img class="ml-5" src="static/img/participant-portal/info_button.svg" alt="info_button" />
                    </a>
                    <div v-if="information" v-show="upHere">
                      <span class="tooltiptext milestone-tooltip" v-if="information.type == 'Milestone'" v-html="information.message"></span>
                    </div>
                  </div>
                </div>
                <ul id="milestone_progress">
                  <li v-for="(mile, index) in milestones" :key="index">
                    <div v-show="index < 5">
                      <div class="node" :class="mile.bulletColur"></div>
                      <p :key="`${mile.milestoneId}_milestoneName`" v-translate:dynamic_string="{ key: `${mile.milestoneId}_milestoneName`, val: lang, html: mile.milestoneName }">{{ mile.milestoneName }}</p>
                      <div class="upcoming" v-if="mile.upcoming" v-html="nextMilestone(mile.upcoming.months, mile.upcoming.milestonedays)"></div>
                      <template v-if="index < milestones.length - 1 && index < 5 - 1">
                        <div class="divider black" :class="mile.progressLine"></div>
                      </template>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="text-center pt-10 pb-10" v-show="milestones.length > 5">
              <button class="btn bg-lightgray primary-text" data-toggle="modal" data-target="#exampleModal"><span v-translate:dashboard_milestone_view_all_title="lang">View All</span>&nbsp;<span v-translate:dashboard_milestones="lang">Milestones</span></button>
            </div>
            <div class="view-btn text-center pt-10 pb-10" v-if="hasSpecificClient">
              <button class="btn primary-bg" @click="insightPage()" v-translate:rsb_consent_view_response_insights="lang">{{ viewResponseInsight ? viewResponseInsight : "View Response Insights" }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal for milestone -->

    <!-- Modal -->
    <div class="modal fade view-milestone" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <label class="modal-heading" v-translate:dashboard_milestones="lang">Milestones</label>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-30">
            <div class="card-body select-scroll">
              <ul id="milestone_progress" class="popup-list">
                <li v-for="(mile, index) in milestones" :key="index">
                  <div>
                    <div class="node" :class="mile.bulletColur"></div>
                    <p :key="`${mile.milestoneId}_milestoneName`" v-translate:dynamic_string="{ key: `${mile.milestoneId}_milestoneName`, val: lang, html: mile.milestoneName }">{{ mile.milestoneName }}</p>
                    <div class="upcoming" v-if="mile.upcoming" v-html="nextMilestone(mile.upcoming.months, mile.upcoming.milestonedays)"></div>
                    <template v-if="index < milestones.length - 1">
                      <div class="divider black" :class="mile.progressLine"></div>
                    </template>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import localStorageService from "@/services/localStorage";
import Doughnut from "@/components/charts/doughnat-legend-dynamic";
import { Graph, Activities, Bitrise, Widget, ParticipantPortal } from "@/components/services/participant-service";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "dashboard",
  props: ["studyId"],
  data() {
    return {
      widget: new Widget(),
      contentLoaded: false,
      activities: [],
      graph: new Graph(),
      portal: new ParticipantPortal(),
      activityList: [],
      options: {
        legend: {
          position: "bottom",
          align: "center",
          fullWidth: false,
          labels: {
            fontSize: 14,
            boxWidth: 4,
            fontColor: "#666"
          }
        },
        events: []
      },
      completed: {
        month: 0,
        day: 0
      },
      remaining: {
        month: 0,
        day: 0
      },
      completedPercent: 0,
      remainingPercent: 0,
      bitrise: new Bitrise(),
      studyVersionId: "397b95ba-cfea-4531-886c-a791e43bd31a",
      taskIdList: [],
      getSchedules: null,
      statusActivity: null,
      todayActivityData: [],
      countRemaining: { status: "", message: "" },
      information: null,
      adherences: [],
      upHere: false,
      totalActivityCount: 0,
      totalCompletedTask: 0,
      checkForStudyStart: null,
      viewResponseInsight: null
    };
  },
  components: {
    Doughnut
  },
  computed: {
    ...mapGetters(["participant", "token", "participantStudyStartStatus"]),
    hasSpecificClient() {
      // Display "View Response Insights" button only for PPMD Client
      this.viewResponseInsight = this.widget.translate("rsb_consent_view_response_insights", "View Response Insights");
      return this.$store.getters.appStateClientId == "654121";
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    user() {
      return this.$store.getters.participant;
    },
    globalElement() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    lang() {
      let selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    data() {
      const completedTitle = this.widget.translate("dashboard_completed_title", "Completed");
      const remainingTitle = this.widget.translate("dashboard_remaining_title", "Remaining");
      return {
        datasets: [
          {
            data: [this.completedPercent, this.remainingPercent],
            borderWidth: 0,
            borderColor: "#0000ff",
            backgroundColor: [this.globalElement ? this.globalElement.primaryColor : "var(--primary)"]
          }
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [completedTitle, remainingTitle]
      };
    },
    milestones() {
      let mileStoneList = [];
      if (this.study && this.study.milestonesList) {
        const mileStoneListScreening = this.study.milestonesList.filter(o => o.isDoNotShowTimeline == false);
        mileStoneList = _.sortBy(mileStoneListScreening, "milestoneType");
        const participantDaysInStudy = this.portal.getCurrentDay();
        let inc = 0;
        mileStoneList.forEach((value, i) => {
          if (participantDaysInStudy > value.milestoneDay) {
            mileStoneList[i].bulletColur = "black";
            if (i == mileStoneList.length - 1) {
              mileStoneList[i].progressLine = "hideen";
            } else {
              mileStoneList[i].progressLine = "activated";
            }
          } else if (participantDaysInStudy == value.milestoneDay) {
            mileStoneList[i].bulletColur = "primary-bg";
            if (i == mileStoneList.length - 1) {
              mileStoneList[i].progressLine = "hideen";
            }
          } else {
            const milestoneDifference = Math.abs(participantDaysInStudy - value.milestoneDay);
            const months = parseInt(milestoneDifference / 30);
            const milestonedays = parseInt(milestoneDifference % 30);
            mileStoneList[i].bulletColur = "lightgrey";
            mileStoneList[i].progressLine = "hideen";
            if (inc < 1) {
              mileStoneList[i].upcoming = {
                months: months,
                milestonedays: milestonedays
              };
              inc++;
            }
          }
        });
        return mileStoneList;
      } else {
        return [];
      }
    },
    progressBarPercentage() {
      if (this.study) {
        const totalDaysInStudy = this.portal.getCurrentDay();
        return Math.floor((totalDaysInStudy / this.study.studyDuration) * 100);
      } else {
        return 0;
      }
    }
  },
  created() {
    this.checkForManualStudyStart();
    this.getAdheranceData();
  },
  methods: {
    checkForManualStudyStart() {
      const userObj = localStorageService.getItem("userObj");
      if (this.study && this.study.isManualStudyStart) {
        if (!this.participantStudyStartStatus.isConfirmed && userObj.startDate == 0) {
          this.checkForStudyStart = this.widget.translate("dashboard_awaiting_study_to_start_label", "Awaiting Study to start").replace(/\\n/g, "  ");
        }
      }
    },
    insightPage() {
      this.$router.push({ name: "participants-portal-insight" });
    },
    nextMilestone(months, days) {
      let string = "";
      const upcomingTitle = this.widget.translate("dashboard_upcoming_in_label", "Upcoming in");
      const daysTitle = this.widget.translate("dashboard_days_title", "days");
      const dayTitle = this.widget.translate("dashboard_day_title", "day");
      const monthTitle = this.widget.translate("dashboard_month_title", "mo");

      switch (true) {
        case months > 0 && days > 1:
          string = `${upcomingTitle} <b>${months}</b> ${monthTitle} <b>${days}</b> ${daysTitle}`;
          break;
        case months > 0 && days == 1:
          string = `${upcomingTitle} <b>${months}</b> ${monthTitle} <b>${days}</b> ${dayTitle}`;
          break;
        case months == 0 && days == 1:
          string = `${upcomingTitle} <b>${days}</b> ${dayTitle}`;
          break;
        case months == 0 && days > 1:
          string = `${upcomingTitle} <b>${days}</b> ${daysTitle}`;
          break;
        case months > 0 && days == 0:
          string = `${upcomingTitle} <b>${months}</b> ${monthTitle}`;
          break;
        default:
          string = "";
      }
      return string;
    },
    getAdheranceData() {
      this.$api
        .getParticipantAdharance({
          participantId: this.participant.pid,
          studyId: this.studyId
        })
        .then(response => {
          this.adherences = response.data.results;
          this.getTodayActivitiesList();
        })
        .catch(() => {
          this.loading = false;
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    CalculateTaskCompletion() {
      let completedCount = 0;
      this.totalActivityCount = this.activities.filter(it => !it.activityIsOptional).length;
      this.activities.forEach(act => {
        if (!act.activityIsOptional && act.completedCount > 0) {
          completedCount++;
        }
      });
      this.totalCompletedTask = completedCount;

      const totalDaysInStudy = this.portal.getCurrentDay();
      this.completed.month = parseInt(totalDaysInStudy / 30);
      const singleTotalDayVal = totalDaysInStudy / 30;
      this.completed.day = Math.floor((totalDaysInStudy % 30) + (singleTotalDayVal - Math.floor(singleTotalDayVal)));

      const remainingObj = this.study.studyDuration - totalDaysInStudy;
      this.remaining.month = parseInt(remainingObj / 30);
      const singleRemainingDayVal = remainingObj / 30;
      this.remaining.day = Math.ceil((remainingObj % 30) - (singleRemainingDayVal - Math.floor(singleRemainingDayVal)));

      const remainingTaskCount = this.totalActivityCount - this.totalCompletedTask;
      if (this.activities.length > 0) {
        this.completedPercent = this.totalActivityCount > 0 ? parseInt((this.totalCompletedTask / this.totalActivityCount) * 100) : 0;
        this.remainingPercent = this.totalActivityCount > 0 ? parseInt((remainingTaskCount / this.totalActivityCount) * 100) : 0;
      } else {
        this.statusActivity = this.widget.translate("dashboard_no_activities_for_today", "No activities for today");
      }

      if (this.completedPercent <= 0) {
        this.remainingPercent = 100;
      } else {
        this.remainingPercent = 100 - this.completedPercent;
      }

      const message = this.widget.translate("dashboard_activities_remaining_title", "Activities Remaining:");
      this.countRemaining =
        this.remainingPercent == 100 && this.remainingPercent == 0
          ? {
              status: true,
              message: this.widget.translate("dashboard_todays_no_remaining_activities", "No Remaining Activities")
            }
          : { status: false, message: message + " " + remainingTaskCount };
    },
    getActivityListData(tasksListOld) {
      let tasksList = tasksListOld;
      let bitScheduleObj;
      const stringObj = this.bitrise.getJsonData("tasks_and_schedules");
      if (stringObj) {
        stringObj.then(response => {
          bitScheduleObj = response.schedules;
          this.activityList = response.schedules;
          const scheduledCurrentVersionTaskIds = bitScheduleObj.map(it => it.tasks[0].taskID);
          tasksList = tasksList.filter(it => scheduledCurrentVersionTaskIds.indexOf(it.taskId) > -1);
          const startDay = this.portal.getCurrentDay();
          const taskIdList = tasksList.map(o => o.taskId);
          const scheduleObj = bitScheduleObj;
          const postData = {
            taskIdList: taskIdList,
            schedule: { schedules: scheduleObj }
          };

          this.$api
            .getPortalDashboardData(this.participant.pid, this.studyId, startDay, { participantId: this.participant.pid, web: true }, postData)
            .then(response => {
              const activityDataList = response.data;
              const activityDataMap = activityDataList.map(o => o.taskId);
              const that = {
                activityDataMap: activityDataMap,
                activityDataList: activityDataList
              };
              this.activities = tasksList.map(o => {
                if (that.activityDataMap.includes(o.taskId)) {
                  const thisTask = that.activityDataList.find(i => i.taskId == o.taskId);
                  o.completedCount = thisTask.completedCount > o.completedCount || o.completedCount === undefined ? thisTask.completedCount : o.completedCount;
                  o.scheduledCount = thisTask.scheduledCount;
                }
                return o;
              }, that);
              this.CalculateTaskCompletion();
              this.contentLoaded = true;
            })
            .catch(() => {
              this.loading = false;
              const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
              if (message) {
                this.$toastr.error(message);
              }
            });
        });
      }
    },
    getTodayActivitiesList() {
      const startDay = this.portal.getCurrentDay();
      if (Object.keys(this.participant).length > 0 && this.participant.pid !== "" && startDay >= 0) {
        this.$api
          .getParticipantsScheduledActivities(this.participant.pid, this.participant.myStudyVersionId, { startDay: startDay, endDay: startDay })
          .then(response => {
            const adherences = response.data.participantTaskAdherence;
            const adherenceExtra = this.adherences.map(o => {
              return {
                taskId: o.taskId,
                studyId: o.studyId,
                studyVersionId: o.studyVersionId,
                deviceId: o.deviceId
              };
            });
            const adherenceTaskIds = adherences.map(o => {
              const taskExtra = adherenceExtra.find(i => i.taskId == o.taskId);
              return taskExtra ? Object.assign(o, taskExtra) : o;
            });
            const activity = new Activities(adherenceTaskIds, response.data.participantTaskSchedules);
            const activityData = activity.getScheduledActivities(new Date());
            const tasksList = [];
            activityData.forEach(data => {
              tasksList.push(data);
            });
            this.statusActivity = null;
            if (tasksList.length == 0) {
              this.statusActivity = this.widget.translate("dashboard_no_activities_for_today", "No activities for today");
            }
            this.getActivityListData(tasksList);
          })
          .catch(() => {
            const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
            if (message) {
              this.$toastr.error(message);
            }
          });
      } else {
        this.activities = [];
      }
    },
    oncallInformation(infoType) {
      this.information = null;
      const progressMsgKeyOverall = this.widget.translate("dashboard_info_overall_progress", "is an estimated value based on your proposed start and end dates. Actual progress may differ by some days.");
      const progressMsgKeyTodays = this.widget.translate("dashboard_info_todays_activities", "shows your daily activity progress.");

      const createInfo = [
        {
          message: `<b>${this.widget.translate("dashboard_over_progress", "Overall Progress")}</b>` + " " + progressMsgKeyOverall,
          type: "Overall"
        },
        {
          message: `<b>${this.widget.translate("dashboard_todays_activities", "Today’s Activities")}</b>` + " " + progressMsgKeyTodays,
          type: "today"
        },
        {
          message: `<b>${this.widget.translate("dashboard_milestones", "Milestones")}</b>` + " " + this.widget.translate("dashboard_info_milestone", "are key events in your participation timeline."),
          type: "Milestone"
        }
      ];
      this.information = createInfo.find(value => value.type == infoType);
    },
    activityPage() {
      this.$router.push({ name: "participants-portal-activities" });
    }
  }
};
</script>
<style scoped lang="scss">
.progress-box {
  width: 100%;
  height: auto;
  padding: 22px 30px 13px;
  border-radius: 8px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.14);
  background-color: #ffffff;
}
.nav-header {
  width: 100%;
  height: 50px;
  border-bottom: solid 1px #d8e3e7;
}

.progress-box .progress-bar {
  background-color: var(--secondary);
}
.progress-box .status-completed {
  padding: 0 143px 0 88px;
}
.progress-box .status-remaining {
  padding: 0 88px 0 143px;
}
.progress-box .status-completed {
  border-right: 3px solid rgba(59, 84, 120, 0.5);
}
.progress-box .progress-status .title {
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: var(--primary);
}
.progress-box .progress-status .title.black {
  color: black;
}
.progress-box .progress-status .text1 {
  font-size: 30px;
  font-weight: 500;
}
.progress-box .progress-status .text3 {
  letter-spacing: -3px;
}
.progress-container {
  width: 100%;
  height: calc(100vh - 130px);
  padding: 48px 213px;
  width: 100%;
  /* height: calc(100vh - 250px); */
  background-image: radial-gradient(#fff, rgba(255, 255, 255, 0)), -webkit-gradient(linear, left top, left bottom, from(#f3f3f4), to(#f3f3f4));
  background-image: radial-gradient(#fff, rgba(255, 255, 255, 0)), linear-gradient(to bottom, #f3f3f4, #f3f3f4);
  overflow-y: auto;
}
.progress-container .activity-section {
  width: auto;
  height: auto;
  flex-grow: 0;
  border-radius: 8px;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.14);
  background-color: #e4e8eb;
}
.progress-container .activity-section .card {
  width: 100%;
  min-height: 480px;
  border: none;
}
.progress-container .activity-section .card .card-title {
  font-family: RobotoRegular;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.progress-container .btn {
  font-size: 14px;
  font-weight: bold;
  padding: 14px 180px;
  border-radius: 10px;
}

.view-milestone .card-body.select-scroll {
  height: 486px;
  overflow: auto;
}
.bg-lightgreen {
  background-color: var(--secondary) !important;
}
.bg-lightgray {
  background-color: #e4e8eb;
}
.view-btn .btn {
  padding: 13px 75px;
  font-size: 17px;
  border-radius: 10px;
  color: #ffffff;
}

.view-milestone .modal-header {
  position: relative;
  padding: 25px 14px 30px;
}
.view-milestone .modal-header .close {
  padding: 5px 14px 10px;
  margin: -1rem -1rem -1rem auto;
  color: #666669;
}
.view-milestone .modal-heading {
  position: absolute;
  left: 40%;
  margin: 0 0 22px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #4a4a4a;
}

.chart-container {
  margin-top: 30px;
}

#milestone_progress .node {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  display: inline-block;
  transition: all 1000ms ease;
}

#milestone_progress.popup-list {
  margin: 0;
}

#milestone_progress .divider {
  height: 40px;
  width: 2px;
  margin-left: 7px;
  transition: all 800ms ease;
  opacity: 0;
}
#milestone_progress .divider.activated {
  opacity: 1;
}

#milestone_progress li p {
  display: inline-block;
  margin-left: 25px;
  margin-bottom: 0px;
}

#milestone_progress li {
  list-style: none;
  line-height: 1px;
}

#milestone_progress .blue {
  background-color: rgba(82, 165, 255, 1);
}
#milestone_progress .green {
  background-color: var(--primary);
}
#milestone_progress div.primary-bg + p {
  color: var(--primary);
}
#milestone_progress .red {
  background-color: rgba(255, 148, 148, 1);
}
#milestone_progress .grey {
  background-color: var(--secondary);
}
#milestone_progress .black {
  background-color: black;
}
#milestone_progress div.black + p {
  color: black;
}
#milestone_progress .lightgrey {
  background-color: rgba(201, 201, 201, 1);
}

.view-milestone.modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.view-milestone .modal-dialog {
  display: inline-block;
  vertical-align: middle;
}

.dashboard-info.tooltip {
  position: relative;
  display: inline-block;
  z-index: 1;
  opacity: 1;
}

.dashboard-info.tooltip .tooltiptext {
  visibility: hidden;
  width: 320px;
  background-color: #ffffff;
  color: #a1a1a1;
  text-align: center;
  font-family: Roboto;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 120%;
  left: -146.5px;
  opacity: 0;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  padding: 5px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
}

.dashboard-info.tooltip .tooltiptext::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #ffffff transparent;
}

.dashboard-info.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.rtl-lang .overall-progress-info {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
}
</style>
